
import Translator from '../translations';

import type { Action } from '../actions/types';
import {
  SWITCH_LOCALE,SET_CONFIG,CACHE_KIOSK_PUBLICATIONS,
} from '../actions/appConfig';
export type State = {
  locale: string,
  // maxAccount: number,
  // appName: string,
  // kioskId: number,
  // kiosk: object,
}

const initialState = {
  locale: 'fr',
  kioskPublications:[],
  // kioskId: 7,
  // kiosk: {},
  // maxAccount: 1,
  // appName: 'ProPress',
  // readerUrl: 'http://readerv2.kioskpress.fr?token=',
};

export default function (state:State = initialState, action:Action): State {

    if (action.type === SWITCH_LOCALE){
      Translator.locale = action.locale;
      return {
        ...state,
        locale:action.locale,
      }
    }
    else if (action.type === SET_CONFIG){
      const config = action.config;

      return {
        ...state,
        ...config,
      }
    }
    else if (action.type === CACHE_KIOSK_PUBLICATIONS){
      const kioskPublications = action.kioskPublications;

      return {
        ...state,
        kioskPublications,
      }
    }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/appConfig.js